import React, {useEffect, useRef, useState} from 'react';
import {informePagoCompensacion, traerFechaPago} from "../../../api/informes.service";
import {UsePermissions} from "../../../hooks/usePermissions";
import {UseLoader} from "../../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {useReactToPrint} from "react-to-print";
import {ContainerPrintAll} from "../../../components/PagoDeduccion/ContainerPrintAll";
import {confirmDialog} from "primereact/confirmdialog";

export const InformepagosTotal = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const [fechaPago, setFechaPago] = useState([]);
    const toast = useRef(null);
    const componentRef = useRef(null);
    const [selectedFecha, setSelectedFecha] = useState({
        fecha_pago: "",
        anio: "",
        mes: ""
    });
    const [FilteredFecha, setFilteredFecha] = useState(null);
    const [dataPagos, setDataPagos] = useState([]);

    const confirmFecha = () => {
        confirmDialog({
            message: 'Filtrar ultimas 3 fechas',
            header: 'confirmacion',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: () => acceptFunc(),
            reject: () => rejectFunc()
        });
    }

    const acceptFunc = () => {
        handleLoad(true)
        traerFechaPago('S').then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setFechaPago([])
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
            setFechaPago(r.data)

        }).catch(() =>   handleLoad(false))


    }

    const rejectFunc = () => {
        handleLoad(true)
        traerFechaPago('N').then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setFechaPago([])
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
            setFechaPago(r.data)

        }).catch(() =>   handleLoad(false))
    }

    useEffect(() => {

        confirmFecha()
        return () => {

        };
    }, []);

    useEffect(() => {
        fechaPago.map((obj) => {
            if (obj.fecha_pago.split('T')[0] === selectedFecha.fecha_pago) {
                return  setSelectedFecha({...selectedFecha, anio: obj.anio, mes: obj.mes});
            }
        })
    }, [selectedFecha.fecha_pago]);

    const handlePrint = useReactToPrint({
        documentTitle: "Pago Compensación TOA",
        content: () => componentRef.current,
        onBeforePrint:() => handleLoad(true),
        onAfterPrint: () => handleLoad(false),
    });

    const searchFechaPago = (event) => {
        setTimeout(() => {
            let _filteredFecha;
            if (!event.query.trim().length) {
                _filteredFecha = [...fechaPago];
            } else {
                _filteredFecha = fechaPago.filter((fecha) => {
                    return fecha.fecha_pago.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredFecha(_filteredFecha);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.fecha_pago.split('T')[0]}</div>
            </div>
        );
    }

   const onSelect = (e) => {

       if (e.fecha_pago !== undefined) {
           const formatoFecha = e.fecha_pago.split('T')[0];
           setSelectedFecha({...selectedFecha, fecha_pago: formatoFecha})
       } else {
           setSelectedFecha({...selectedFecha, fecha_pago: ''})
       }

   }

    const buscarPagos = () => {
        if (selectedFecha.fecha_pago === "" ) {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)

        const payLoad = {
            fecha: selectedFecha.fecha_pago,
            mes: selectedFecha.mes,
            anio: selectedFecha.anio,
        }
        /** informes info */
        informePagoCompensacion(payLoad).then(r => {
            handleLoad(false)

            if (r.estado !== 200) {
                setDataPagos([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }


            if (r.data.length > 0) {
                setDataPagos(r.data);
            }

        }).catch(r => handleLoad(false))

    }
    return (
        <>
            <Toast ref={toast}/>
            <div className="container-relative">
                <ContainerTable>
                    <div className="px-2">
                        <div className=" flex flex-wrap items-center  p-4 primary-color">
                            {permisos.consultar === 1 && fechaPago.length > 0 ?
                                <div className=" mt-2 relative lg:w-4/12 px-4">
                                    <AutoComplete value={selectedFecha} suggestions={FilteredFecha}
                                                  style={{"width": "100%"}}
                                                  completeMethod={searchFechaPago}
                                                  placeholder="Buscador de fecha pago"
                                                  size="30"
                                                  field="fecha_pago" dropdown itemTemplate={itemTemplate}
                                                  onChange={(e) => onSelect(e.value)}/>
                                </div>
                                : ""}
                            <div className=" mt-2 relative lg:w-4/12 px-4">
                                <button
                                    className="warning-color-btn btn w-full"
                                    type="button"
                                    onClick={buscarPagos}
                                >
                                    Buscar
                                </button>
                            </div>
                            {dataPagos.length > 0 && <div className=" mt-2 relative lg:w-4/12 px-4">
                                <button
                                    className="secundary-color-btn btn w-full"
                                    type="button"
                                    onClick={handlePrint}
                                >
                                    Imprimir
                                </button>
                            </div>}
                        </div>

                    </div>
                    {dataPagos.length > 0 &&  <ContainerPrintAll
                        ref={componentRef}
                        datapagos={dataPagos}
                    />}
                </ContainerTable>
            </div>
        </>
    );
};


